import { render, staticRenderFns } from "./Blabel.vue?vue&type=template&id=e7dad850&"
import script from "./Blabel.vue?vue&type=script&lang=js&"
export * from "./Blabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports